export default (name: string, url?: string): string | null => {
  const targetUrl = url || window.location.href;
  const escapedName = name.replace(/[[\]]/g, '\\$&');

  const regex = new RegExp(`[?&]${escapedName}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(targetUrl);

  if (!results) return null;
  if (!results[2]) return '';

  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};
